import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
// import { ChangeCcComponent } from '../change-cc/change-cc.component';

@Component({
  selector: 'app-flight-list',
  templateUrl: './flight-list.component.html',
  styleUrls: ['./flight-list.component.css']
})
export class FlightListComponent implements OnInit {

  public menu_item_id = '118';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['flight_number', 'flight_name', 'start_airport', 'end_airport', 'flight_start_date', 
    'flight_end_date', 'ticket_num', 'customize', 'edit', 'cancel'];
  // , 'flight_date', 'registered_count', 'chagne_cc'
  displayedColumns2 = ['flight_number', 'flight_name', 'start_airport', 'end_airport', 'flight_start_date', 
    'flight_end_date', 'ticket_num'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'flight', 'flight_name': '', 'flight_number': '', 'flight_start_date': new Date(),
    'flight_end_date': new Date(), 'start_airport': '0', 'end_airport': '0', 'title': 'رحلات الطيران'
  };

  search_airport = {
    'placeholder': 'اسم المطار', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airport', 'selected_no': 'airport_id',
      'field_list': ['airport_name', 'airport_name_en', 'airport_code']
    }]
  };

  // changeDialogRef: MatDialogRef<ChangeCcComponent>;

  Success_Msg; Error_Msg; Del_Flight_Msg; 
  Flight_list; Search_Msg; Airport_Name;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, public translate: TranslateService) { 
      this.getMessages(translate);
    }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Flight_Msg').subscribe((res: string) => {
      this.Del_Flight_Msg = res;
    });

    translate.get('Flight_list').subscribe((res: string) => {
      this.Flight_list = res;
    });
    this.model['title'] = this.Flight_list;

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Airport_Name').subscribe((res: string) => {
      this.Airport_Name = res;
    });
    this.search_airport['placeholder'] = this.Airport_Name;
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let date = new Date();
    this.model['flight_start_date'] = new Date(date.getFullYear(), date.getMonth(), 1);
    this.model['flight_end_date'] = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  onChangeFromAirport = function (search_result: object) {
    this.model['start_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToAirport = function (search_result: object) {
    this.model['end_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  search() {
    if (this.model['flight_name'] == '' && this.model['flight_number'] == '' && 
      this.model['start_airport'] == '' && this.model['end_airport'] == '' && 
      this.model['flight_start_date'] == undefined && this.model['flight_end_date'] == undefined) {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getFlightList', 'group_by_no': '1' };

    if (this.model['flight_name'] != '')
      obj['flight_name'] = this.model['flight_name'];

    if (this.model['flight_number'] != '')
      obj['flight_number'] = this.model['flight_number'];
    
    if (this.model['start_airport'] != '0')
      obj['start_airport'] = this.model['start_airport'];

    if (this.model['end_airport'] != '0')
      obj['end_airport'] = this.model['end_airport'];

    if (this.model['flight_start_date'] != undefined) 
      obj['flight_start_date'] = this.model['flight_start_date'].getFullYear() + "-" + 
        (this.model['flight_start_date'].getMonth() + 1) + "-" + this.model['flight_start_date'].getDate();

    if (this.model['flight_end_date'] != undefined) 
      obj['flight_end_date'] = this.model['flight_end_date'].getFullYear() + "-" + 
        (this.model['flight_end_date'].getMonth() + 1) + "-" + this.model['flight_end_date'].getDate();

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'][0]['depart_list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Flight_list + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('flight_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  // changeCC(row) {
  //   let dialog_data = [{
  //   'table_name': 'flight', 'id': row.flight_id, 'cost_center': row.cost_center 
  //   }];

  //   this.changeDialogRef = this.dialog.open(ChangeCcComponent, {
  //     hasBackdrop: false,
  //     data: dialog_data
  //   });
  //   this.changeDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       // if (result != null && result['op_type'] == 'success') {
  //       //   this.search();
  //       // }
  //     });
  // }

  cancel(row) {
    if (confirm(this.Del_Flight_Msg)) {
      let obj;

      let values = [];
      values.push({ 'table_name': this.model['table_name'], 'flight_no': row.flight_no });

      let query = "SELECT `invoice_no` FROM `invoice`, `flight` WHERE " + 
        "`invoice`.`flight_id` = `flight`.`flight_id` AND `flight`.`flight_no` = '" + row.flight_no + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let invoice_list = data.data['list'];

          invoice_list.forEach(element => {
            values.push({ 'table_name': 'invoice', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'invoice_item', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'inv_payment_method', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'trip_group', 'invoice_no': element.invoice_no });
            values.push({ 'table_name': 'reg_on_ticket', 'invoice_no': element.invoice_no });
          });

          obj = { cmd: 'deleteRec', values: values };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              if (data.status['type'] == 'success') {
                alert(this.Success_Msg);
                this.search();
              }
              else {
                alert(this.Error_Msg);
              }
            });
        });
    }
  }
}
